export const BadgeSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="66"
      height="67"
      viewBox="0 0 66 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.7841 43.7276C47.4812 58.2954 33.0008 67 33.0008 67C33.0008 67 18.5204 58.2954 11.2175 43.7276C3.67434 28.68 3.30078 10.5753 3.30078 10.5753L33.0008 0L62.7008 10.5753C62.7008 10.5753 62.3272 28.68 54.7841 43.7276Z"
        fill="#ECF0F1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.992 58.2887C28.731 55.0727 21.3113 48.6193 16.9929 39.9696C12.5894 31.1484 10.8846 20.9262 10.2325 14.925L32.9986 6.78516L55.7646 14.925C55.1132 20.9215 53.4091 31.1457 49.0042 39.9689C44.7076 48.5771 37.2543 55.062 32.992 58.2887Z"
        fill="#E64C3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.4425 30.8482C43.3856 28.8489 43.3842 25.6094 41.4425 23.6101C40.9737 23.1255 40.4126 22.7428 39.7934 22.4852C39.1742 22.2277 38.5099 22.1007 37.8409 22.112C36.0213 22.1435 33.0203 24.6218 33.0203 24.6218C33.0203 24.6218 29.9348 22.1087 28.0703 22.1114C27.4167 22.1126 26.7698 22.2458 26.1674 22.5031C25.565 22.7604 25.0189 23.1367 24.561 23.6101C22.6193 25.6094 22.618 28.8489 24.561 30.8482L33.0018 39.5307L41.4425 30.8482Z"
        fill="white"
      />
      <path
        opacity="0.08"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.0008 0L3.30078 10.5753C3.30078 10.5753 3.67434 28.68 11.2175 43.7276C18.5204 58.2954 33.0008 67 33.0008 67V0Z"
        fill="black"
      />
    </svg>
  )
}
